module.exports = __webpack_public_path__ + "static/media/as_airdrop_mask.9152dbf4.png";